export var dataHooks = {
  infoIconRoot: 'info-icon-root'
};